import { render, staticRenderFns } from "./SvgCompany.vue?vue&type=template&id=42364916&scoped=true&"
import script from "./SvgCompany.vue?vue&type=script&lang=js&"
export * from "./SvgCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42364916",
  null
  
)

export default component.exports